export default {
	title: 'timer',
	components: [{ title: 'auto', component: 'auto_gen_z' }],
};
